import LayoutSectionContent from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout-section-content";

import { PreviewSidebarItemType } from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";
import { LayoutResponsivePadding } from "containers/admin/clients/client/theme-page/preview/preview.types";
import {
  BlockType,
  DeviceType,
  PaddingPropertyType,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout.types";

export const LAYOUT_TAB_SIDEBAR: PreviewSidebarItemType[] = [
  {
    titleText: "CONTENT AREA",
    children: <LayoutSectionContent sectionName="contentArea" />,
    isOpen: true,
  },
  {
    titleText: "CONTENT BLOCKS",
    children: <LayoutSectionContent sectionName="contentBlock" />,
    isOpen: true,
  },
];

export const MOBILE_VALUE = "mobile";
export const DESKTOP_VALUE = "desktop";
export const LEFT_VALUE = "left";
export const RIGHT_VALUE = "right";
export const TOP_VALUE = "top";
export const BOTTOM_VALUE = "bottom";
export const HEADINGS_VALUE = "headings";
export const PARAGRAPH_VALUE = "paragraph";
export const BUTTON_VALUE = "button";

// Arrays for iteration
export const BLOCK_TYPES: BlockType[] = [HEADINGS_VALUE, PARAGRAPH_VALUE, BUTTON_VALUE];
export const DEVICE_TYPES: DeviceType[] = [MOBILE_VALUE, DESKTOP_VALUE];
export const PADDING_PROPERTIES: PaddingPropertyType[] = [
  LEFT_VALUE,
  TOP_VALUE,
  RIGHT_VALUE,
  BOTTOM_VALUE,
];

export const LAYOUT_DEFAULT: LayoutResponsivePadding = {
  mobile: {
    left: "10",
    right: "10",
    top: "10",
    bottom: "10",
    isCustom: false,
  },
  desktop: {
    left: "10",
    right: "10",
    top: "10",
    bottom: "10",
    isCustom: false,
  },
};
